import {createContext} from 'react';
import {DynamicWalletConnectWrapper} from '@stripe-internal/wallet-connect-wrapper';

type WalletConnectionClientContextType = {
  walletClientRef: React.RefObject<DynamicWalletConnectWrapper | null>;
};

export const WalletConnectionClientContext = createContext<
  WalletConnectionClientContextType | undefined
>(undefined);
